import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-14 md:py-24 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20ambient%20lighting%2C%20luxurious%20red%20velvet%20seats%2C%20large%20screen%20with%20soft%20glow%2C%20elegant%20atmosphere%2C%20professional%20cinema%20photography%2C%20warm%20golden%20and%20crimson%20tones%2C%20clean%20background&width=1800&height=800&seq=cta-bg-01&orientation=landscape"
        alt="麻豆传媒观影体验"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          开启你的专属观影之旅
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto leading-relaxed">
          加入麻豆传媒，畅享海量正版高清影视内容。无论是独家原创剧集还是经典佳作，随时随地，想看就看。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/#membership"
            className="px-8 py-3.5 rounded-full bg-accent-500 text-background-950 font-semibold text-sm hover:bg-accent-400 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-accent-500/30"
          >
            立即加入会员
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/all"
            className="px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-sm hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer border border-white/20"
          >
            浏览全部作品
          </Link>
        </div>
      </div>
    </section>
  );
}